<template>
  <main class="home-page">
    <section class="home-hero" aria-labelledby="home-title">
      <swiper ref="mySwiper" :options="swiperOptions" class="hero-swiper">
        <swiper-slide v-for="slide in heroSlides" :key="slide.image" class="hero-slide">
          <img :src="slide.image" :alt="slide.alt" class="hero-image" />
        </swiper-slide>
        <div slot="button-prev" class="swiper-button-prev hero-control" aria-label="上一张">
          <img src="../assets/images/navigationImg/left.png" alt="" />
        </div>
        <div slot="button-next" class="swiper-button-next hero-control" aria-label="下一张">
          <img src="../assets/images/navigationImg/right.png" alt="" />
        </div>
      </swiper>

      <div class="hero-overlay"></div>
      <div class="home-container hero-content">
        <h1 id="home-title">让档案管理创造<br />更长期的组织价值</h1>
        <p class="hero-description">面向政府、企业与高校，提供覆盖档案全生命周期的数字化产品、解决方案与专业服务。</p>
        <div class="hero-actions">
          <el-button class="hero-primary" type="primary" @click="openTrialDialog">免费体验</el-button>
          <router-link class="hero-secondary" to="/products">了解产品</router-link>
        </div>
      </div>
    </section>

    <products />

    <section id="solutions" class="home-section-anchor" aria-label="解决方案">
      <solution />
    </section>

    <section class="home-value" aria-labelledby="value-title">
      <div class="home-container">
        <header class="section-heading">
          <h2 id="value-title">为什么选择禾祺科技</h2>
          <p>以专业能力、可靠技术和持续服务，让每一份档案都安全、规范、可用。</p>
        </header>
        <div class="value-grid">
          <article v-for="(card, index) in valueCards" :key="card.title" class="value-card">
            <img :src="card.image" :alt="card.imageAlt" class="value-card-image" />
            <div class="value-card-body">
              <img :src="card.icon" alt="" class="value-card-icon" />
              <h3>{{ card.title }}</h3>
              <p>{{ card.description }}</p>
            </div>
          </article>
        </div>
      </div>
    </section>


    <aptitude />
    <customer />
    <min-news />
  </main>
</template>

<script>
import solution from '@/views/components/solution.vue'
import aptitude from './components/aptitude.vue'
import products from './components/products.vue'
import customer from './components/customer.vue'
import minNews from './components/minNews.vue'

export default {
  components: { solution, aptitude, products, customer, minNews },
  inject: ['openTrialDialog'],
  data () {
    return {
      swiperOptions: {
        autoplay: { delay: 6000, disableOnInteraction: false },
        loop: true,
        speed: 900,
        navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }
      },
      heroSlides: [
        { image: require('../assets/images/lunbo/ai.jpg'), alt: '禾祺科技数字档案服务' },
      ],
      valueCards: [
        {
          title: '安全、可靠',
          description: '以安全算法、数据加密和完善的备份恢复机制，守护档案数据全生命周期安全。',
          icon: require('../assets/images/home/icon-aqtx.png'),
          image: require('../assets/images/solution/index1.webp'),
          imageAlt: '安全可靠的数字档案管理'
        },
        {
          title: '专业、规范',
          description: '以国家档案建设规范为基础，结合单位实际情况提供可落地的建设方案。',
          icon: require('../assets/images/home/icon-dptfg.png'),
          image: require('../assets/images/solution/index2.webp'),
          imageAlt: '规范的档案建设服务'
        },
        {
          title: '咨询服务',
          description: '由行业经验丰富的团队提供规划、实施和培训支持，推动服务持续落地。',
          icon: require('../assets/images/home/icon-zjzyfw.png'),
          image: require('../assets/images/solution/index3.webp'),
          imageAlt: '专业档案咨询服务'
        },
        {
          title: '稳定、智能',
          description: '分布式架构结合 OCR、全文检索和数据分析能力，持续释放档案数据价值。',
          icon: require('../assets/images/home/icon-ppjc.png'),
          image: require('../assets/images/solution/index4.webp'),
          imageAlt: '智能化档案管理能力'
        }
      ]
    }
  },
  methods: {}
};
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?3cf590d7972e5f00e69a95f8be65a94f";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();

</script>

<style scoped>
.home-page { overflow: hidden; color: #20344e; }
.home-container { width: min(1200px, calc(100% - 64px)); margin: 0 auto; }
.home-hero { position: relative; min-height: 720px; color: #fff; }
.hero-swiper { position: absolute; inset: 0; width: 100%; height: 100%; }
.hero-slide { width: 100%; height: 100%; }
.hero-image { display: block; width: 100%; height: 100%; object-fit: cover; }
.hero-overlay { position: absolute; inset: 0; background: linear-gradient(90deg, rgba(14, 32, 55, 0.78), rgba(14, 32, 55, 0.28) 62%, rgba(14, 32, 55, 0.1)); z-index: 1; pointer-events: none; }
.hero-content { position: relative; z-index: 2; display: flex; min-height: 720px; flex-direction: column; justify-content: center; padding-top: 72px; }
.hero-content h1 { margin: 0; font-size: clamp(42px, 4.2vw, 64px); font-weight: 600; line-height: 1.25; letter-spacing: 0.03em; }
.hero-description { max-width: 600px; margin: 26px 0 34px; color: rgba(255, 255, 255, 0.86); font-size: 18px; line-height: 1.85; }
.hero-actions { display: flex; gap: 16px; align-items: center; }
.hero-primary { min-width: 126px; height: 46px; border: 0; background: #1f5dea; font-size: 15px; }
.hero-secondary { display: inline-flex; align-items: center; justify-content: center; min-width: 126px; height: 44px; border: 1px solid rgba(255, 255, 255, 0.8); color: #fff; font-size: 15px; text-decoration: none; }
.hero-secondary:hover, .hero-secondary:focus { border-color: #fff; background: rgba(255, 255, 255, 0.12); outline: none; }
.hero-control { z-index: 3; display: flex; width: 48px; height: 48px; align-items: center; justify-content: center; border: 1px solid rgba(255, 255, 255, 0.45); background: rgba(14, 32, 55, 0.25); }
.hero-control::after { display: none; }
.hero-control img { width: 18px; height: auto; }
.home-value { padding: 104px 0 112px; background: #f5f8fc; }
.section-heading { max-width: 690px; margin: 0 auto 52px; text-align: center; }
.section-heading h2 { margin: 0; color: #20344e; font-size: clamp(30px, 3vw, 40px); font-weight: 600; line-height: 1.35; }
.section-heading > p:last-child { margin: 18px 0 0; color: #728197; font-size: 16px; line-height: 1.8; }
.value-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 18px; }
.value-card { overflow: hidden; border: 1px solid #e8edf4; background: #fff; box-shadow: 0 10px 28px rgba(35, 64, 102, 0.06); transition: transform 0.25s ease, box-shadow 0.25s ease; }
.value-card:hover { box-shadow: 0 18px 34px rgba(35, 64, 102, 0.13); transform: translateY(-6px); }
.value-card-image { display: block; width: 100%; aspect-ratio: 1.2; object-fit: cover; }
.value-card-body { position: relative; min-height: 220px; padding: 28px 24px 25px; }
.value-card-number { position: absolute; top: 25px; right: 22px; color: #dce8fc; font-size: 30px; font-weight: 600; }
.value-card-icon { width: 44px; height: 44px; object-fit: contain; }
.value-card h3 { margin: 19px 0 11px; color: #20344e; font-size: 20px; font-weight: 600; }
.value-card p { margin: 0; color: #718096; font-size: 14px; line-height: 1.8; }
.home-section-anchor { scroll-margin-top: 72px; }
@media (max-width: 1024px) { .home-hero, .hero-content { min-height: 620px; } .value-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 22px; } .value-card-body { min-height: 184px; } }
@media (max-width: 768px) { .home-container { width: calc(100% - 40px); } .home-hero, .hero-content { min-height: 580px; } .hero-content { padding-top: 64px; } .hero-content h1 { font-size: 38px; } .hero-description { margin: 18px 0 28px; font-size: 15px; } .hero-control { display: none; } .home-value { padding: 68px 0 74px; } .section-heading { margin-bottom: 34px; } .section-heading > p:last-child { font-size: 14px; } .value-grid { grid-template-columns: 1fr; } .value-card { display: grid; grid-template-columns: 42% 1fr; } .value-card-image { height: 100%; aspect-ratio: auto; } .value-card-body { min-height: 190px; padding: 23px 18px; } .value-card h3 { margin-top: 14px; font-size: 18px; } .value-card p { font-size: 13px; } .value-card-number { top: 20px; right: 18px; font-size: 25px; } }
@media (max-width: 480px) { .hero-content h1 { font-size: 32px; } .hero-actions { gap: 10px; } .hero-primary, .hero-secondary { min-width: 112px; } .value-card { grid-template-columns: 1fr; } .value-card-image { aspect-ratio: 1.65; } }
@media (prefers-reduced-motion: reduce) { .value-card { transition: none; } .value-card:hover { transform: none; } }
</style>
